<div class="content-page content-contact py-5">
  <div class="d-flex flex-column flex-lg-row gap-4 gap-lg-5">
    <div class="w-100 d-flex flex-column gap-0 gap-lg-5">
      <div class="mb-4">
        <h1 class="fs-1 contact-text fw-bold mb-3 mb-lg-0">Conversemos</h1>
        <p class="fw-light text-white text-contact">Déjanos tus datos y un asesor Kaizen se pondrá en contacto contigo:</p>
      </div>
      <div class="mt-0 mt-lg-5">
        <p class="text-white fw-bold fs-5 text-contact-title">Kaizen Wealth Planning Ltd.</p>
        <div class="d-none d-lg-inline">
          <p class="text-white fw-light mb-1">Company number: 2177969</p>
          <p class="text-white fw-light mb-1">British Virgin Islands.</p>
          <p class="text-white fw-light mb-1">kaizen&#64;gmail.com</p>
        </div>
        <div class="d-flex gap-3 align-items-center content-icons-social mt-0 mt-lg-5">
          <img src="assets/svg/icon-linkdn-white.svg" alt="logo" width="24">
          <img src="assets/svg/icon-twitter-white.svg" alt="logo" width="24">
          <img src="assets/svg/icon-instagram-white.svg" alt="logo" width="24">
        </div>
      </div>
      <div class="btn-send w-100 d-lg-flex align-items-center justify-content-center mt-4 pointer d-none" (click)="sendMessage()">
        <span class="text-blue fs-5">Enviar mensaje</span>
      </div>
    </div>

    <form [formGroup]="formContact" class="w-100">
      <div class="w-100 d-flex flex-column gap-3">
        <div class="w-100 mt-4">
          <div>
            <span class="text-white fs-6 fw-light question">Nombres y apellidos</span>
          </div>
          <mat-form-field class="w-100">
            <input matInput formControlName="name">
            <mat-error *ngIf="formContact.get('name')?.hasError('required')">Este campo es obligatorio</mat-error>
          </mat-form-field>
        </div>
        <div class="w-100">
          <div>
            <span class="text-white fs-6 fw-light question">Número telefónico</span>
          </div>
          <div class="d-flex gap-3">
            <mat-form-field class="w-25">
              <mat-select class="text-white" formControlName="codePhone">
                <mat-option value="+57">+57</mat-option>
                <mat-option value="+55">+55</mat-option>
                <mat-option value="+56">+56</mat-option>
              </mat-select>
              <mat-error *ngIf="formContact.get('codePhone')?.hasError('required')">Seleccione una opción</mat-error>
            </mat-form-field>
            <mat-form-field class="w-75">
              <input matInput formControlName="phone" appOnlyNumber>
              <mat-error *ngIf="formContact.get('phone')?.hasError('required')">Este campo es obligatorio</mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="w-100">
          <div>
            <span class="text-white fs-6 fw-light question">Correo electrónico</span>
          </div>
          <mat-form-field class="w-100">
            <input matInput formControlName="email">
            <mat-error *ngIf="formContact.get('email')?.hasError('required')">Este campo es obligatorio</mat-error>
            <mat-error *ngIf="formContact.get('email')?.hasError('email')">El formato del correo electrónico es
              incorrecto</mat-error>
          </mat-form-field>
        </div>
        <div class="w-100">
          <div>
            <span class="text-white fs-6 fw-light question">Mensaje</span>
          </div>
          <mat-form-field class="w-100">
            <textarea matInput rows="5" formControlName="message"></textarea>
            <mat-error *ngIf="formContact.get('message')?.hasError('required')">Este campo es obligatorio</mat-error>
          </mat-form-field>
        </div>
        <div class="btn-send w-100 d-flex align-items-center justify-content-center mt-1 mt-d-4 pointer d-lg-none" (click)="sendMessage()">
          <span class="text-blue fs-5">Enviar mensaje</span>
        </div>
      </div>
    </form>
  </div>
</div>